/**
 * Small display helpers shared by the rep access screens.
 *
 * This used to hold a whole tree layout. The reporting tree was removed on 2026-08-27 in favour of
 * free-form access lists, and the layout went with it - what is left is the handful of functions
 * that were never about hierarchy: naming a rep, comparing a ref that may or may not be populated,
 * and reading clinic names off a rep.
 */

/** A rep's display name, falling back to their email when the name fields are empty. */
export function repName(rep) {
  if (!rep) return '';
  const name = `${rep.firstName || ''} ${rep.lastName || ''}`.trim();
  return name || rep.email || '';
}

/** A ref that may be a raw id, an ObjectId, or a populated { _id } - as a comparable string. */
export function refId(value) {
  if (value === null || value === undefined) return '';
  return String(value._id ?? value);
}

/** The clinics a rep covers, as display names (the API populates them; ids degrade to nothing). */
export function repClinicNames(rep) {
  return (rep?.clinics || []).map((c) => c?.name).filter(Boolean);
}

/** Case-insensitive match on name, email, or any covered clinic name. */
export function repMatches(rep, term) {
  const needle = String(term || '').trim().toLowerCase();
  if (!needle) return true;
  const haystack = [repName(rep), rep.email || '', ...repClinicNames(rep)].join(' ').toLowerCase();
  return haystack.includes(needle);
}
